import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectBuildingCranageTypesTypeFilter } from 'shared/selectors/advancedFilters';
import { EBuildingCraneType } from '../../../../../../../packages/api-models/common/json_query';
import { NonEmptyArray } from '../../../../../../../packages/JsonQuery';

export const BuildingCranageTypesTypeContainer: FC = () => {
  const { label, value, options } = useSelector(selectBuildingCranageTypesTypeFilter);

  const onChange = useFilterChangeCallback();

  const handleBuildingCranageTypesTypeChange = useCallback(
    (newValue: NonEmptyArray<EBuildingCraneType> | null) => {
      onChange({ action: 'setBuildingCranageTypesType', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter
        value={value}
        options={options}
        onFilterChange={handleBuildingCranageTypesTypeChange}
      />
    </AdvancedFilterRow>
  );
};
